import React from "react";
import ExportCSVPaginated from "./ExportCsvPaginated";
import Loader from "./Loader";
import "./table.scss";

const Table = ({
  datas,
  fields,
  exportOptions,
  fullWidth,
  isLoading = false, // additive (C1) : overlay de chargement sans saut de hauteur
  style = {},
  tdStyle = {},
  // Style optionnel par ligne, reçoit la donnée de la ligne. En inline et non en
  // classe : `table-striped` l'emporterait en spécificité sur une classe
  // contextuelle, et la mise en évidence n'apparaîtrait qu'une ligne sur deux.
  rowStyle,
}) => {
  return (
    <div
      className="table-shell mt-2 mx-auto"
      style={{ maxWidth: fullWidth ? "100%" : "95%" }}
    >
      {exportOptions && (
        <div
          className="d-flex align-items-center justify-content-end mb-2"
          data-priv="export_csv"
        >
          <ExportCSVPaginated
            fields={[
              ...(exportOptions.fields || fields),
              ...(exportOptions?.additionalFields || []),
            ]}
            datas={exportOptions.datas}
            exportOptions={{ ...exportOptions, paginated: true }}
            csvDelimiter={exportOptions.csvDelimiter || ","}
          />
        </div>
      )}

      <div className="table-scroll" aria-busy={isLoading || undefined}>
        <table className="table custom-table" style={{ ...style }}>
          <thead>
            <tr>
              {fields.map((h, hk) => (
                <th key={"thk" + hk} scope="col">
                  {h.name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {datas.map((d, dk) => (
              <tr key={"dk" + dk} style={rowStyle ? rowStyle(d) : undefined}>
                {fields.map((f, fk) => (
                  <td key={"df" + dk + "" + fk} style={tdStyle}>
                    {f.render
                      ? f.render(f.path == "*" ? d : d[f.path])
                      : d[f.path]}
                  </td>
                ))}
              </tr>
            ))}
            {!datas.length && !isLoading && (
              <tr>
                <td className="table-empty" colSpan={fields.length}>
                  <i className="fa fa-inbox" aria-hidden="true" />
                  <span>Aucun résultat</span>
                  <small>Modifiez votre recherche ou vos filtres.</small>
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {isLoading && (
          <div className="table-loading">
            <Loader />
          </div>
        )}
      </div>
    </div>
  );
};

export default Table;
